module.exports = __webpack_public_path__ + "static/media/AROUND.51911df3.jpeg";